export default __webpack_public_path__ + "static/media/3814.ee38dd45.png";